<template>
  <div class="login-card content bind">
    <div class="top-operate">
      <el-button type="text" class="back-button" @click="onGoBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </el-button>
    </div>
    <div class="title default">微信登录手机号</div>
    <div class="wechat-login-desc">
      <div class="content">
        <span class="label">首次扫码提示：</span>
        <span>① 关注 精彩纵横云采购 公众号</span>
        <i class="el-icon-arrow-right icon-arrow"></i>
        <span>② 绑定登录手机号</span>
      </div>
    </div>
    <el-form ref="form" :rules="rules" class="form" :model="form">
      <!-- 电话号码 -->
      <el-form-item prop="mobile">
        <el-input
          v-model.trim="form.mobile"
          class="height-input"
          placeholder="请输入电话号码"
          size="medium"
        >
          <i slot="prefix" class="icon iconfont icon-zhanghao"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model.trim="form.password"
          placeholder="请输入密码"
          show-password
          class="height-input"
          @keyup.enter.native="bindAndLogin"
        >
          <i slot="prefix" class="icon iconfont icon-mima"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          class="one-line"
          :loading="loading"
          type="primary"
          size="medium"
          @click="bindAndLogin"
        >立即绑定</el-button>
      </el-form-item>
    </el-form>

    <!-- 注册引导 -->
    <div class="register-guide">
      <div>
        <el-button type="text" @click="onRegister">注册</el-button>
        <el-button
          type="text"
          class="expert-register"
          @click="onExpertRegister"
        >评审专家注册</el-button>
      </div>
      <div>
        <!-- 忘记密码 -->
        <el-button
          v-if="currentWay === 0 && !useQrLogin"
          type="text"
          :underline="false"
          @click="onForget"
        >
          忘记密码
        </el-button>
      </div>
    </div>

    <!-- 轮播图 -->
    <banner-list class="banner-list" />
  </div>
</template>

<script>
import { logoutApi, weChatLoginByAccountApi } from '@/api/user'
import { enterCompanyApi, getJoinCompanyApi } from '@/api/employee'
import BannerList from '@/views/login/components/BannerList'

export default {
  name: 'Bind',
  components: {
    BannerList
  },
  data() {
    return {
      form: {
        mobile: '',
        password: ''
      },
      loading: false,
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入账号',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^\d{11}$/,
            message: '请正确输入11位手机号码',
            trigger: ['blur']
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },

  computed: {
    returnUrl() {
      return this.$route.query.returnUrl
    },

    ticket() {
      return this.$route.query.ticket
    }
  },

  methods: {

    // 跳转至企业注册页面
    onRegister() {
      this.$router.push({ name: 'Register' })
    },

    // 跳转至专家注册页面
    onExpertRegister() {
      this.$router.push({ name: 'ExpertRegister' })
    },

    onGoBack() {
      logoutApi()
        .then(res => {
          this.$store.commit('system/UPDATE_LOGIN', 'out')
          if (res.success) {
            this.$router.back()
          }
        })
        .catch(err => {
          this.$message.error(err.data.message || '登出失败，请稍后重试')
        })
    },

    async bindAndLogin() {
      const requestData = Object.assign(
        {
          ticket: this.ticket
        },
        this.form
      )
      this.loading = true
      try {
        await weChatLoginByAccountApi(requestData)
        this.getJoinCompany()
      } catch (err) {
        this.loading = false
        if (err.data) {
          this.$message.error(err.data.message || '绑定失败，请稍后重试')
        }
      }
    },

    getJoinCompany() {
      this.loading = true
      getJoinCompanyApi()
        .then(res => {
          const companyList = res.data || []
          if (companyList.length === 1) {
            this.enterCompany(companyList[0])
          } else {
            window.location.href = `${process.env.VUE_APP_LOGIN_JUMP_URL}`
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(
            err.data?.message || '获取已加入企业失败，请稍后重试'
          )
        })
    },

    enterCompany(company) {
      this.loading = true
      const temp = {
        employeeId: company.employeeId,
        companyId: company.companyId
      }
      enterCompanyApi(temp)
        .then(res => {
          if (res.success) {
            // 登录成功后跳转
            window.location.href =
              this.returnUrl || `${process.env.VUE_APP_LOGIN_JUMP_URL}`
          }
        })
        .catch(err => {
          this.$message.error(err.data?.message || '登录企业失败，请稍后重试')
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.bind {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 100px 28px !important;
  .top-operate {
    left: 29px;
    top: 29px;
  }
  .default {
    width: 100%;
    font-size: 18px;
    text-align: center;
    margin-top: -32px;
  }
  .wechat-login-desc{
    margin-top: -10px;
    margin-bottom: 24px;
    font-size: 12px;
    width: 100%;
    .content {
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      width: 100%;
    }
    .label {
      font-weight: bold;
    }
    .icon-arrow {
      margin-left: 6px;
      margin-right: 6px;
    }
  }

  .form {
    width: 340px;
    margin-left: 22px;
  }

  .register-guide {
    width: 100%;
    margin-top: 18px;
    margin-left: 22px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .expert-register {
      border-left: 1px solid $info-fourth-color;
      padding-left: 10px;
    }
  }

  .banner-list {
    width: 340px;
    height: 80px;
    margin-left: 22px;
    margin-top: 26px;
  }
}
</style>
